// extracted by mini-css-extract-plugin
export default {"heading":"HkK4V","component":"CV85F","animate":"Mlyhr","tariffs":"QGZX9","tariffCard":"qAZmT","buttonsGroup":"qnDVA","decline":"smjuK"};